import { useState } from "react";

export default function SidebarHook() {
    const [status, setStatus] = useState(true);
    const open = () => { setStatus(true) };
    const close = () => setStatus(false);
    const toggle = () => setStatus(!status);

    return {
        status: status,
        func: {
            open,
            close,
            toggle
        },
    };
}